import React, { useState, useEffect } from "react";
import { navlinks } from "../../constant";
import { useLocation, Link } from "react-router-dom";
import logo from '../../assets/images/libcloud_logo.svg';
import "../../styles/Navbar.css"
import { Dropdown } from 'react-bootstrap'

const Navbar = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const currentPath = location.pathname;
        const index = navlinks.findIndex((item) => item.path === `/${currentPath.split("/")[1]}`);
        console.log(index);
        setActiveIndex(index);
        window.scrollTo(0, 0);
    }, [location]);

    const toggleMenu = () => {
        setMenuOpen((prevState) => !prevState);
    };


    return (
        <nav className="navbar d-flex align-items-center justify-content-between w-100 sticky-top z-10 bg-white">
            <div className="navbar-logo bg-transparent">
                <Link to="/">
                    <img src={logo} alt="LibCloud" />
                </Link>
                <button
                    className={`menu ${menuOpen ? "open" : ""}`}
                    onClick={toggleMenu}>
                    <span className="menu-span1"></span>
                    <span className="menu-span2"></span>
                    <span className="menu-span3"></span>
                </button>
            </div>
            <ul className={`navbar-links ${menuOpen ? "open" : ""} d-flex flex-direction-row`}>
                {navlinks.map((item, index) => (
                    <li
                        key={index}
                        className={`navbar-item ${activeIndex === index ? 'active' : ""}`}
                    >
                        {!item.subMenu ? <Link
                            to={item.path}
                            onClick={() => {
                                setActiveIndex(index);
                                setMenuOpen(false);
                            }}>
                            {item.title}
                        </Link>
                            : <Dropdown >
                                <Dropdown.Toggle className="dropdown">
                                    {item.title}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {
                                        item.subMenu.map((subItem, index) => (
                                            <Dropdown.Item className="sublink" onClick={() => {
                                                setMenuOpen(false);
                                            }}><Link to={subItem.path}>{subItem.title}</Link></Dropdown.Item>
                                        ))
                                    }
                                </Dropdown.Menu>
                            </Dropdown>}
                    </li>
                ))}
            </ul>
        </nav>
    );
}

export default Navbar;